import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { languages, useLanguage } from "./Langs";
import Navbar from "./Navbar";
import GetLogo from "./GetLogo";

const Decline = (props) => {
  let [openHelp, setOpenHelp] = React.useState(false);

  const [lang, setLang] = useLanguage();
  let logo = GetLogo();

  return (
    <div style={{ backgroundColor: "#e0e0e0" }}>
      <Navbar
        lang={[lang, setLang]}
        disableToolBar
        openHelp={openHelp}
        color={logo.color}
        helpColor={logo.helpColor}
        banner={logo.banner}
        setOpenHelp={setOpenHelp}
      ></Navbar>

      <link
        rel="stylesheet"
        href="https://use.fontawesome.com/releases/v5.13.0/css/all.css"
        integrity="sha384-Bfad6CLCknfcloXFOyFnlgtENryhrpZCe29RTifKEixXQZ38WheV+i/6YWSzkz3V"
        crossOrigin="anonymous"
      />

      <div
        style={{ marginTop: "100px", marginLeft: "15px", marginRight: "15px" }}
      >
        <div
          style={{
            backgroundColor: "white",
            width: "100%",
            maxWidth: "600px",
            height: "auto",
            marginTop: "150px",
            textAlign: "center",
            margin: "0 auto",
            borderStyle: "solid 2px #000",
            border: "2px solid #0A213C",
            borderRadius: "25px",
            padding: "25px",
            borderColor: "transparent",
            boxShadow: "10px 10px 5px rgba(1, 1, 1, 0.5)",
          }}
        >
          <span
            style={{
              textAlign: "left",
              fontSize: "50px",
              fontFamily: "Arial, Helvetica, sans-serif",
              fontWeight: "bold",
              lineHeight: "1.2em",
              marginBottom: "2px",
            }}
          >
            {lang.DocumentDeclined}
          </span>

          <hr
            style={{
              width: "70%",
              margin: "0 auto",
              marginTop: "20px",
              marginBottom: "20px",
              display: "block",
            }}
          ></hr>

          <p
            style={{
              fontSize: "18px",
              fontFamily: "Arial, Helvetica, sans-serif",
              lineHeight: "1.7em",
            }}
          >
            {" "}
            {lang.LeavePage}
          </p>
        </div>

        <p style={{ textAlign: "center", margin: "50px", marginTop: "40px" }}>
          {lang.Experience}: <br></br>
          <a href="mailto:info@myshs.com">info@myshs.com</a>
        </p>
      </div>
    </div>
  );
};
export default Decline;
